import React from 'react'
import styled from 'styled-components';
import { device } from "../device";

const BlockHeader = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 0 0 48px;
    @media ${device.sm} {
        align-items: center;
        flex-direction: row;
        margin: 0 0 64px;
    }
`;

export default React.memo(BlockHeader);